package com.essntl.features.client.ui.allclients.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem2
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.key.upDownSelection
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun ClientListColumn(
    clientState: PaginationState<ClientModel>,
    modifier: Modifier = Modifier,
    selectedClient: ClientModel,
    onEditClient: (clientId: String) -> Unit,
    onLoadMoreClient: () -> Unit,
) {
    val scope = rememberCoroutineScope()
    val lazyListState = rememberLazyListState()

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(vertical = EsConstants.SectionVerticalPadding),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .height(EsConstants.ListRowItemHeight)
                .pointerHoverIcon(PointerIcon.Hand)
                .padding(horizontal = EsConstants.SectionHorizontalPadding * 2),
        ) {
            // Name
            EsRowDefaultItem2(
                text = "Name",
                weight = 2f,
            )

            // Email
            EsRowDefaultItem2(
                text = "Email",
            )

            // Telephone
            EsRowDefaultItem2(
                text = "Telephone",
            )
        }

        LazyColumn(
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
            state = lazyListState,
            contentPadding = PaddingValues(
                vertical = EsConstants.SectionVerticalPadding,
            ),
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
                .background(color = MaterialTheme.esColorScheme.bgSecondaryHover),
        ) {
            itemsIndexed(clientState.data, key = { _, r -> r.id }) { index, client ->

                val isSelected = rememberEquals(client.id, setOf(selectedClient.id)) { it }

                val focusRequester = remember { FocusRequester() }

                LaunchedEffect(isSelected) {
                    delay(100L)
                    if (isSelected)
                        focusRequester.requestFocus()
                }

                ClientItem(
                    client = client,
                    isSelected = isSelected,
                    showDivider = index != clientState.data.lastIndex,
                    onEditClient = { onEditClient(client.id) },
                    modifier = Modifier
                        .upDownSelection(
                            focusRequester = focusRequester,
                            isSelected = isSelected,
                            list = clientState.data,
                            index = index,
                            onSelect = { onEditClient(it.id) },
                            lazyListState = lazyListState,
                            scrollTo = {
                                scope.launch {
                                    lazyListState.scrollToItem(it)
                                }
                            },
                        )
                        .padding(
                            horizontal = EsConstants.SectionHorizontalPadding,
                        )
                        .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                )
            }

            if (!clientState.isLastPage) {
                item {
                    Spacer(modifier = Modifier.height(2.spacing))
                    EsMediumOutlineButton(
                        onClick = {
                            onLoadMoreClient()
                        },
                        text = "Load more",
                        loading = clientState.isLoading,
                        modifier = Modifier
                            .align(Alignment.CenterHorizontally),
                    )
                    Spacer(modifier = Modifier.height(2.spacing))
                }
            }
        }
    }
}